import { TradingPlatformName } from './../types'
export const RESTRICTED_DOMAINS: Array<{
    host: string
    platforms: Array<TradingPlatformName>
}> = [
        {
            host: "portal.thinktrader.com",
            platforms: ["ThinkTrader"]
        }
    ]